import { Context } from '@leverege/plugin';
import { Toast } from '@leverege/ui-elements';
import { getContractPDF } from '../../util/Interface';
export default {
  id: 'recovr.downloadLocatorAgreement',
  name: 'Download Locator Device Agreement PDF',
  layout: {
    sort: 'recovrSaleActions.downloadAgreement.j',
    sectionName: 'RecovR Sale Actions',
    group: ['Download RecovR Contract']
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: 'location.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'sale',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.sales',
    objectType: 'sale'
  }, {
    use: ['contextMenu', 'mobileActionBar'],
    path: 'company.locations.sales',
    objectType: 'sale'
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  handles: cxt => {
    const targets = Context.getTargetsOfType(cxt, 'sale');
    if (targets == null || targets.length === 0 || targets.length > 1) {
      return false;
    }
    return targets[0]?.data?.data?.type === 'vehicle-with-locator' && (targets[0]?.data?.data?.productTypes?.recovr === true || targets[0]?.data?.data?.productTypes == null);
  },
  appearance: () => {
    return {
      name: 'Locator Customer Contract PDF',
      icon: 'https://recovr-ui-assets.storage.googleapis.com/menu-icons/download.png'
    };
  },
  perform: async props => {
    const {
      context
    } = props;
    const sale = Context.getTargetsOfType(context, 'sale')[0];
    const systemId = sale?.data?.systemId;
    const companyId = sale?.data?.data?.company?.id;
    const locationId = sale?.data?.data?.location?.id || sale?.data?.data?.sales?.id;
    const saleId = sale?.data?.id;
    const filename = `RecovR Locator Agreement - ${sale?.data?.data?.name}.pdf`; // eslint-disable-line max-len

    try {
      await getContractPDF({
        systemId,
        companyId,
        locationId,
        saleId,
        filename
      });
    } catch (err) {
      Toast.error('Error downloading agreement');
    }
  }
};